<template>
  <v-dialog v-model="showDialog" max-width="800" scrollable>
    <v-card>
      <v-card-title class="d-flex">
        Equipment Check Detail
        <v-spacer></v-spacer>
        <v-btn icon @click="showDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="loading" class="text-center py-8">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-card-text>
      <v-card-text v-else-if="check">
        <v-row dense>
          <v-col cols="12" sm="4">
            <p class="caption grey--text mb-0">Date</p>
            <p>{{ check.check_date }}</p>
          </v-col>
          <v-col cols="12" sm="4" v-if="check.checked_by">
            <p class="caption grey--text mb-0">Checked By</p>
            <p>{{ check.checked_by.full_name || check.checked_by.username }}</p>
          </v-col>
          <v-col cols="12" sm="4" v-if="check.branch">
            <p class="caption grey--text mb-0">Branch</p>
            <p>{{ check.branch.branch_name }}</p>
          </v-col>
        </v-row>
        <div v-for="section in sections" :key="section.title">
          <p class="subtitle-2 mt-4 mb-2">{{ section.title }}</p>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Equipment</th>
                  <th>Location</th>
                  <th>Status</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in section.rows" :key="item.id">
                  <td>{{ item.equipment ? item.equipment.name : "—" }}</td>
                  <td>
                    {{
                      item.equipment ? item.equipment.designated_location : "—"
                    }}
                  </td>
                  <td>
                    <v-chip small :color="statusColor(item.status)" dark>
                      {{ statusLabel(item.status) }}
                    </v-chip>
                  </td>
                  <td>{{ item.remarks || "—" }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <template v-if="check.notes">
          <p class="caption grey--text mb-0 mt-4">Notes</p>
          <p>{{ check.notes }}</p>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["show", "checkId"],
  computed: {
    showDialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
    sections() {
      const groups = [
        { title: "Facility Equipment", rows: [] },
        { title: "Tools", rows: [] },
      ];
      ((this.check && this.check.items) || []).forEach((i) => {
        const type = i.equipment && i.equipment.type;
        groups[type === "tool" ? 1 : 0].rows.push(i);
      });
      return groups.filter((g) => g.rows.length);
    },
  },
  data() {
    return {
      loading: false,
      check: null,
    };
  },
  watch: {
    show(value) {
      if (value && this.checkId) this.load();
    },
  },
  methods: {
    ...mapActions({
      get_equipment_check: "facilities/get_equipment_check",
    }),
    async load() {
      this.loading = true;
      this.check = null;
      try {
        this.check = await this.get_equipment_check(this.checkId);
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
    statusColor(status) {
      const colors = {
        working: "green",
        needs_repair: "orange",
        broken: "red",
        missing: "deep-purple",
        present: "blue",
      };
      return colors[status] || "grey";
    },
    statusLabel(status) {
      const labels = {
        working: "Working",
        needs_repair: "Needs Repair",
        broken: "Broken",
        missing: "Missing",
        present: "Present",
      };
      return labels[status] || status;
    },
  },
};
</script>
